import { render, staticRenderFns } from "./Grid-delivery-ranking.vue?vue&type=template&id=e1783972&scoped=true&lang=pug"
import script from "./Grid-delivery-ranking.vue?vue&type=script&lang=js"
export * from "./Grid-delivery-ranking.vue?vue&type=script&lang=js"
import style0 from "./Grid-delivery-ranking.vue?vue&type=style&index=0&id=e1783972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1783972",
  null
  
)

export default component.exports